export const WIDGET_SERVER_ENVIRONMENTS = {
  DRAFT: "draft",
  PREVIEW: "preview"
};

/**
 * Resolves which widget server the snippet should connect to.
 * An explicit url (e.g. a branch deployer's own widget server) wins;
 * otherwise the draft or preview url is taken from the environment.
 */
export const resolveWidgetServerUrl = ({ environment = WIDGET_SERVER_ENVIRONMENTS.PREVIEW, url } = {}) => {
  if (url) return url;

  return environment === WIDGET_SERVER_ENVIRONMENTS.DRAFT
    ? import.meta.env.VITE_DRAFT_WIDGET_SERVER_URL
    : import.meta.env.VITE_PREVIEW_WIDGET_SERVER_URL;
};
